export const getSwitcherAccounts = (businessAccounts = [], resumeEntryBA = null) => {
  if (!resumeEntryBA?.id) return businessAccounts

  return businessAccounts.filter((account) => account?.id !== resumeEntryBA.id)
}
